export default __webpack_public_path__ + "static/media/x-circle.df8f8dc3.png";